import React, { useEffect } from 'react';
import { shape, string, bool } from 'prop-types';
import { getFooterConstants, FLOW_TYPES } from './Footer-constants';
import './Footer-sky.scss';

/**
 * Footer component
 * @param {object} props object with footerContext properties.
 * @param {object} props.footerContext
 * @param {string=} props.footerContext.customText string to append at the bottom of the footer only if a value is passed.
 * @param {string=} props.footerContext.variant optional string value to distinguish if the footer componet should render ILOC/TOPUP variant.
 */
// TODO: dangerouslySetInnerHTML should be removed at some point in future not need it.
// @ts-ignore
const Footer = ({ footerContext } = {}) => {
  // support for nested prop default values
  const { customText, variant } = footerContext;
  const flowType = Object.values(FLOW_TYPES).includes(variant) ? variant : FLOW_TYPES.DEFAULT;
  const constants = getFooterConstants(flowType);

  const searchParams = new URLSearchParams(window.location.search);
  const webviewQueryParam = searchParams.get('webview');
  const webview = window.localStorage.getItem('webview');

  const isWebview = webview === 'true' || webviewQueryParam === 'true';

  useEffect(() => {
    const headerElement = document.getElementById('com-header');
    if (isWebview) {
      headerElement?.remove();
    }
  }, [isWebview]);

  return (
    <div className="pl-footer-outer pl-footer-outer--sky">
      <div className="pl-footer pl-footer--sky">
        {isWebview ? null : (
          <div className="pl-footer-left pl-footer-left--sky">
            <div className="pl-footer-logo pl-footer-logo--sky" />
            <address className="pl-footer-address pl-footer-address--sky">
              <div>{constants.address}</div>
              <div>{constants.state}</div>
            </address>
          </div>
        )}
        {isWebview ? null : (
          <div className="pl-footer-right pl-footer-right--sky">
            <ul className="pl-footer-nav pl-footer-nav--sky">
              <li className="pl-footer-nav-li">
                <a href="/" target="_blank" rel="noopener noreferrer">
                  {constants.links.home}
                </a>
              </li>
              <li className="pl-footer-nav-li">
                <a href="/company/about-us" target="_blank" rel="noopener noreferrer">
                  {constants.links.about}
                </a>
              </li>
              <li className="pl-footer-nav-li nav-last-item">
                <a href="/legal/terms-of-use" target="_blank" rel="noopener noreferrer">
                  {constants.links.terms}
                </a>
              </li>
            </ul>
          </div>
        )}
        <div
          className={isWebview ? 'pl-footer-bankDetails pl-footer-bankDetailsWithoutBorder' : 'pl-footer-bankDetails'}
        >
          {constants.generalDisclaimer}
          <p>{constants.copyright}</p>
          <div className="pl-footer-equal pl-footer-equal--sky">{constants.equal}</div>
          {isWebview ? (
            <div>
              <ul className="pl-footer-nav pl-footer-nav--sky">
                <li className="pl-footer-nav-li pl-footer-mobile-first-item pl-footer-mobile-margin-item">
                  <a href="/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
                    {constants.links.privacy}
                  </a>
                </li>
                <li className="pl-footer-nav-li nav-last-item pl-footer-mobile-margin-item">
                  <a href="/legal/terms-of-use" target="_blank" rel="noopener noreferrer">
                    {constants.links.terms}
                  </a>
                </li>
              </ul>
            </div>
          ) : null}
        </div>
      </div>
      {customText && (
        <p className="cms-fragment-footer cms-fragment-footer--sky text-justify">
          <hr className="divider divider--sky" />
          <p dangerouslySetInnerHTML={{ __html: customText }} />
        </p>
      )}
    </div>
  );
};

Footer.propTypes = {
  footerContext: shape({
    customText: string,
    isIloc: bool,
  }),
};

Footer.defaultProps = {
  footerContext: {},
};

export default Footer;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/rc-footer/Footer.scss');